import { useEffect, useState } from "react";
import { createContext } from "react";
import { useQuery } from "react-query";
import axios from "../../axios/axios";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import AAFEdit from "./AAFEdit";
import AAFView from "./AAFView";
export const AasetupContext = createContext(null);
const AAFSetup = () => {
    const [editMode, setEditMode] = useState(false);
    const { authData } = useContext(AuthenticationContext);
    const [AAfData, setAAfData] = useState(null)
    const GetAAFSetupData = async () => {
        const resp = await axios.get(`/approval/advice-flooring`);
        if (resp.status < 400) {
            setAAfData(resp.data?.data);
            if (resp.data?.data === null) {
                setEditMode(true);
            } else {
                setEditMode(false);
            }
        }
    }

    useEffect(() => {
        GetAAFSetupData();
    }, [])
    const {
        isLoading,
        data: AAData,
        refetch,
    } = useQuery(
        ["getApprovalAdivce"],
        async () => {
            const resp = await axios.get("/approval/advice", {
                headers: {
                    Authorization: `Bearer ${authData?.token}`,
                },
            });
            console.log(resp?.data?.data);
            return resp?.data?.data;
        },
        {
            refetchOnWindowFocus: false,
        }
    );
    console.log("AAfData", AAfData)
    return (
        <div className="flex_adjust min-h-screen">
            <AasetupContext.Provider
                value={{ setEditMode, isLoading, AAfData, authData, refetch, GetAAFSetupData }}
            >
                {editMode ? <AAFEdit/> : <AAFView  />}
            </AasetupContext.Provider>
        </div>
    );
};

export default AAFSetup;
